import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var injectScriptSrc = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(src) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve, reject) {
            var script = document.createElement("script");
            script.onload = resolve;
            script.onerror = reject;
            script.src = src;
            document.body.appendChild(script);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function injectScriptSrc(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var injectScriptText = function injectScriptText(textContent) {
  var script = document.createElement("script");
  script.textContent = textContent;
  document.body.appendChild(script);
};
export var matches = function matches(element, selector) {
  return element.matches ? element.matches(selector) : element.msMatchesSelector(selector);
};
export var closest = function closest(element, selector) {
  if (element.closest) {
    return element.closest(selector);
  } else {
    var el = element;
    do {
      if (matches(el, selector)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  }
};
var _getOffsetTop = function getOffsetTop(element) {
  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return element ? _getOffsetTop(element.offsetParent, top + element.offsetTop) : top;
};
export var scrollElementToTopOfViewportIfNotVisible = function scrollElementToTopOfViewportIfNotVisible(element) {
  var DISTANCE_FROM_VIEWPORT_EDGE = 250;
  var isAboveVisibleViewport = element && _getOffsetTop(element) < window.pageYOffset + DISTANCE_FROM_VIEWPORT_EDGE;
  var isBelowVisibleViewport = element && _getOffsetTop(element) > window.pageYOffset + window.innerHeight - DISTANCE_FROM_VIEWPORT_EDGE;
  if (isAboveVisibleViewport || isBelowVisibleViewport) {
    window.scrollTo({
      top: element.offsetTop - DISTANCE_FROM_VIEWPORT_EDGE,
      behavior: "smooth"
    });
  }
};
export var scrollElementIntoView = function scrollElementIntoView(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$margin = options.margin,
    margin = _options$margin === void 0 ? 0 : _options$margin;
  var offsetHeight = element.offsetHeight;
  var offsetTop = _getOffsetTop(element);
  var _window = window,
    pageYOffset = _window.pageYOffset,
    innerHeight = _window.innerHeight;
  var scrollPosMin = offsetTop + offsetHeight - innerHeight + margin;
  var scrollPosMax = offsetTop - margin;
  var top = scrollPosMin <= scrollPosMax ? Math.max(Math.min(pageYOffset, scrollPosMax), scrollPosMin) : scrollPosMax;
  if (top !== pageYOffset) {
    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  }
};